import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import images from "../../../utilities/images/images";
import "./AitsTestInstruction.css";

import HeaderInstruction from "../components/Instruction/HeaderInstruction";

function AitsTestInstruction() {
  const history = useHistory();
  const { instructions } = useSelector((state) => state.examSlice);

  const inst = instructions?.instruction || instructions;

  return (
    <div className="aitstest_instruction">
      <div className="test_container">
        <img
          src={images.new_backarrow}
          alt="back"
          className="arrow_image"
          onClick={() => history.push("/practice/paper-listing")}
          //  onClick={() => history.goBack()}
        />
        <span>Test Instruction</span>
      </div>

      <div className="common_padding">
        <HeaderInstruction
          name={inst?.paper_name}
          type={inst?.paper_type}
          duration={inst?.duration_mins}
          totalQuestions={inst?.total_questions}
          maxMarks={inst?.max_marks}
          date={inst?.start_date}
          instruction_image={`https://learning.motion.ac.in${inst?.instructions_image}`}
          paper_icon={inst?.paper_icon}
          duration_icon={inst?.duration_icon}
          question_icon={inst?.question_icon}
        />

        {inst?.instructions_html && (
          <div className="general_wrapper">
            <div className="general_header">General Instructions</div>

            <div
              className="general_content instructions_html_container"
              dangerouslySetInnerHTML={{ __html: inst?.instructions_html }}
            />
          </div>
        )}

        <div className="start_btn">
          <button
            className="back-tests-btn"
            onClick={() => history.push("/paper-listing")}
          >
            Back
          </button>

          <button
            className="begin-test-btn"
            onClick={() =>
              history.push("/test", {
                paperId: inst?.paper_id,
                paperType: inst?.paper_type,
              })
            }
          >
            <span>Begin Your Test</span>
            <img
              src={images.rightArrow_icon}
              alt="arrow"
              className="arrow-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default AitsTestInstruction;
